import {
  CategoryScale,
  Chart as ChartJS,
  Tooltip as ChartTooltip,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
} from 'chart.js'
import React from 'react'
import { LeadsChartBox } from 'modules/main/components/chart-box-section/leads-chart-box'
import { RevenueChartBox } from 'modules/main/components/chart-box-section/revenue-chart-box'
import { ChartBoxSectionProps } from 'modules/main/components/chart-box-section/types'

ChartJS.register(
  CategoryScale,
  LinearScale,
  Filler,
  PointElement,
  LineElement,
  Title,
  Legend,
  ChartTooltip,
)
export const ChartBoxSection = React.forwardRef<
  HTMLDivElement,
  React.PropsWithRef<ChartBoxSectionProps>
>(function ChartBoxSection({ className, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={`flex flex-col flex-wrap justify-between gap-5 md:flex-row lg:flex-col xl:gap-5 ${className} h-fit xl:flex-row`}
    >
      <LeadsChartBox {...props} />
      <RevenueChartBox {...props} />
    </div>
  )
})
